import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { getEnvironment } from '../env/environment';

const env = getEnvironment();
const browserHistory = createBrowserHistory();

export const reactPlugin = new ReactPlugin();

/**
 * Shared Application Insights client. Created once at module load and exported so features can
 * emit custom telemetry (trackEvent/trackMetric/trackException) on top of the ReactPlugin's
 * automatic route/pageview tracking. Call `loadAppInsights()` once at app start (see index.tsx).
 */
export const appInsights = new ApplicationInsights({
  config: {
    connectionString: env.appInsightsConnectionString,
    // *** If you're adding the Click Analytics plug-in, delete the next line. ***
    extensions: [reactPlugin],
    // *** Add the Click Analytics plug-in. ***
    // extensions: [reactPlugin, clickPluginInstance],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
      // *** Add the Click Analytics plug-in. ***
      // [clickPluginInstance.identifier]: clickPluginConfig
    }
  }
});
